// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1QbBD","validationTips":"StatementDescriptor_validationTips__2qGDm"};